const AVERAGE_TICK_CHAR_WIDTH = 7;

export function getBottomAxisLayout({
  labels,
  tickRotation = 0,
  margin,
  hasLegend,
  minLegendOffset = 56,
}) {
  const maxLen = Math.max(...(labels || []).map((label) => String(label || '').length), 0);
  const rotationRadians = (tickRotation * Math.PI) / 180;
  const rotatedHeight = Math.ceil(maxLen * AVERAGE_TICK_CHAR_WIDTH * Math.abs(Math.sin(rotationRadians)));
  const legendOffset = hasLegend ? Math.max(minLegendOffset, rotatedHeight + 28) : undefined;
  const dynamicBottom = Math.max(margin.bottom, rotatedHeight + (hasLegend ? minLegendOffset : 20));

  return {
    margin: { ...margin, bottom: dynamicBottom },
    legendOffset,
  };
}
